var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useLocale } from "../../../communication";
import { t } from '@mp/locale';
import { formatDates, getDuration, setLanguage, } from "./Scheduler.utils";
import OffHours from "./OffHours";
import SchedulerHead from "./SchedulerHead";
import SchedulerSlots from "./SchedulerSlots";
import SchedulerWeekNav from "./SchedulerWeekNav";
import SchedulerValid from "./SchedulerValid";
import "./Scheduler.scss";
export default function Scheduler(_a) {
    var _b;
    var dates = _a.dates, earliestPossibleDate = _a.earliestPossibleDate, handleDateChange = _a.handleDateChange, order = _a.order, selectedSlot = _a.selectedSlot, setEarliestPossibleDate = _a.setEarliestPossibleDate, setSelectedSlot = _a.setSelectedSlot;
    var language = useLocale().language;
    useEffect(function () {
        setLanguage(language);
    }, [language]);
    var timezone = (_b = order === null || order === void 0 ? void 0 : order.address) === null || _b === void 0 ? void 0 : _b.property_time_zone;
    var timeZoneAbbrev = new Date()
        .toLocaleTimeString("en-us", { timeZoneName: "short", timeZone: timezone })
        .split(" ")[2];
    var _c = useState([]), times = _c[0], setTimes = _c[1];
    var _d = useState({}), selectedDate = _d[0], setSelectedDate = _d[1];
    useEffect(function () {
        var firstAvailable = new Date(dates[0].date);
        var formattedDates = formatDates(firstAvailable, dates, timezone);
        if (!earliestPossibleDate) {
            setEarliestPossibleDate(firstAvailable);
        }
        setTimes(formattedDates);
        setSelectedDate(formattedDates[0]);
    }, [dates]);
    var changeWeek = function (args) {
        setSelectedSlot({});
        handleDateChange(args);
    };
    return (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mp-capturesvc-step-title" }, { children: t("CAPTURE_SERVICES.ORDER.STEPS.schedule.title") })), _jsx("p", __assign({ className: "mp-capturesvc-step-subtitle" }, { children: t("CAPTURE_SERVICES.ORDER.SCHEDULE.title", null, {
                    duration: getDuration(order === null || order === void 0 ? void 0 : order.job_duration),
                }) })), _jsx(SchedulerWeekNav, { earliestPossibleDate: earliestPossibleDate, changeWeek: changeWeek, times: times }), _jsx("div", __assign({ className: "mp-scheduler-timezone-message" }, { children: t("CAPTURE_SERVICES.SCHEDULER.timezoneMessage", null, {
                    timezone: timezone,
                    timeZoneAbbrev: timeZoneAbbrev,
                }) })), _jsxs("div", __assign({ className: "capturesvc-scheduler" }, { children: [_jsx(SchedulerHead, { selectedDate: selectedDate, setSelectedDate: setSelectedDate, setSelectedSlot: setSelectedSlot, times: times }), _jsx(SchedulerSlots, { order: order, selectedDate: selectedDate, selectedSlot: selectedSlot, setSelectedSlot: setSelectedSlot }), _jsx(OffHours, { selectedSlot: selectedSlot }), _jsx(SchedulerValid, { order: order, selectedSlot: selectedSlot })] }))] }));
}
